import './styles/ViewNotifications.scss';
import { System_DeviceOrientationMap } from '../assets/keyMap';
import { AppContext, ExAppContext } from '../Context';
import { useContext, useState, useRef, useEffect } from 'react';
import { IonDateString } from '../components/IonDate';
import { useHistory } from 'react-router';
import { Browser } from '@capacitor/browser';

//components
import ImagePreviewer from '../components/ImagePreviewer';

//classes
import Broadcast from '../classes/broadcast';

//controllers
import ClassController from '../controllers/ClassController';

//mui
import DeleteIcon from '@mui/icons-material/Delete';

//graphics
import PPKMLogo from '../assets/images/logos/ppkmLogo.jpg';

interface Props {

}

const ViewNotifications: React.FC<Props> = ({}) => {
    //contexts
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);
    //states
    const [broadcasts, SetBroadcasts] = useState([] as Broadcast[]);
    //refs
    const broadcastsRef = useRef<Broadcast[]|null>(null);
    //controllers
    const classController_broadcast = new ClassController('Broadcast');
    //router objs
    const history = useHistory();

    //watchers
    //watch for broadcasts update, update local storage
    useEffect(() => {
        if(
            broadcastsRef.current == null
            ||
            (JSON.stringify(appContext.broadcasts) != JSON.stringify(broadcastsRef.current))
        ) {
            broadcastsRef.current = [] as Broadcast[];
            appContext.broadcasts.map((broadcast: Broadcast) => {
                broadcastsRef.current!.push(classController_broadcast.SetPropertiesOfSubject(broadcast, ['read'], ['true']));
            })
            appContext.SetBroadcasts([...broadcastsRef.current]);
        }

        //filter broadcasts remove cleared broadcasts
        const _broadcasts = [] as Broadcast[];
        appContext.broadcasts.map((broadcast: Broadcast) => {
            if(!broadcast.cleared) {
                _broadcasts.push(broadcast);
            }
            SetBroadcasts([..._broadcasts]);
        });
    }, [appContext.broadcasts]);

    //ui functions
    const OnClearBroadcastBtnClicked = (broadcast: Broadcast) => {
        appContext.SetPopupMessage('Are you sure to remove this notification?');
        appContext.SetPopupButtons(['Yes', 'No']);
        appContext.SetPopupActions([() => {
            ClearBroadcastByID(broadcast.broadcastID);
        }, () => {}]);
    }

    //render functions
    const RenderBroadcastCard = (broadcast: Broadcast, i: number) => {
        const BroadcastAction = async() => {
            if(broadcast.action.match(/[{:}]/g)) {
                const actionObj = JSON.parse(broadcast.action) as any;
                const objKey = Object.keys(actionObj)[0];
                switch(objKey) {
                    case 'url':
                        appContext.SetAppStateChangeWatch(false);
                        await Browser.open({url: actionObj[objKey]});
                        Browser.addListener('browserFinished', () => {appContext.SetAppStateChangeWatch(true)});
                        break;
                    case 'push':
                        history.push(actionObj[objKey]);
                        break;
                    case 'action':
                        try {
                            const action = eval(actionObj[objKey]);
                            action();
                        } catch (e: any) {
                            console.log('BroadcastActionErr: ' + e);
                        }
                        break;
                }
            } else
                return null;
        };

        return(
            <div className={'broadcast-card'} key={'broadcast-card-' + i}>
                <div className='bg-mask' onClick={() => BroadcastAction()}/>
                <span className='broadcast-date-lbl'>{IonDateString(broadcast.start_datetime != null ? broadcast.start_datetime : new Date()).split(' ')[0]}</span>
                {
                    broadcast.poster.length > 0 ?
                    <div className='broadcast-card-img'>
                        <ImagePreviewer src={broadcast.poster}/>
                    </div>
                    :
                    <img className='broadcast-card-img' src={PPKMLogo}/>
                }
                <div className='title-block'>
                    <span className='title-lbl'>{broadcast.title}</span>
                    <span className='title-txt'>{broadcast.message}</span>
                </div>
                <button className='clear-btn' onClick={() => OnClearBroadcastBtnClicked(broadcast)}><DeleteIcon /></button>
            </div>
        );
    }

    //exe functions
    const ClearBroadcastByID = (broadcastID: string) => {
        const broadcasts = appContext.broadcasts;
        appContext.broadcasts.map((broadcast: Broadcast, i: number) => {
            if(broadcast.broadcastID == broadcastID) {
                broadcasts.splice(i, 1, classController_broadcast.SetPropertiesOfSubject(broadcast, ['cleared'], ['true']));
            }
        });
        appContext.SetBroadcasts([...broadcasts]);
    }

    return (
        <div className={'ViewNotifications ' + (appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : 'portrait')}>
            {
                broadcasts.map((broadcast: Broadcast, i: number) => {
                    return RenderBroadcastCard(broadcast, i);
                })
            }
            {
                 broadcasts.length == 0 ?
                 <span className='no-notification-lbl'>There're no new notifications<br/>Check back again later.</span>
                 :
                 null
            }
        </div>
    )
}
export default ViewNotifications;